import { BaseApi } from "../utils/request";

export interface AgentCenterRequest {
  phone: string;
  type: "register" | "login" | "reset_password" | "verify";
}

export interface CommissionData {
  totalAmount: number;
  levelData: Array<{
    level?: number;
    validBets?: number;
    bettingRebate?: number;
  }>;
}

export interface AgentCenterResponse {
  todayIncome: CommissionData;
  totalIncome: CommissionData;
}

export interface AgentInvitedInfoResponse {
  agentInvitationLink: string;
  invitedCode: string | null;
}

export interface InvitedInfoResponse {
  todayIncome?: number;
  yesterdayIncome?: number;
  registers?: number;
  validRegisters?: number;
  [key: string]: any;
}

export interface CommissionRecordsRequest {
  pageSize?: number;
  pageIndex?: number;
  userName?: string;
  type?: string;
  dateRange?: {
    start: number;
    finish: number;
  };
}

export interface CommissionRecord {
  // 根据实际返回的数据结构定义
  [key: string]: any;
}

export interface CommissionRecordsResponse {
  page: {
    content: CommissionRecord[];
    totalElements: number;
    totalPages: number;
    size: number;
    number: number;
  };
  totalAmount: number;
}

export interface IncomeConfigResponse {
  players: number;
  winner: number;
  invitationBonusExpr?: string;
  invitationBonusIncomeExpr?: string;
  achievementRewardExpr?: string;
  achievementRewardIncomeExpr?: string;
  bettingRebatesExpr?: string;
  bettingRebatesIncomeExpr?: string;
  incomeAmounts?: string[]; // Leaderboard 排行榜使用的金额数组（字符串格式）
  goalsAmount?: number; // 收入计算器目标金额
  annualIncomeExpr?: string; // 收入计算器年收入表达式
  richTextContent?: string; // 规则
}

export class AgentCenterApi extends BaseApi {
  constructor() {
    super();
  }

  /**
   * 获取收入汇总数据
   * @returns Promise<ApiResponse<IncomeSummaryModel, true>>
   */
  async incomeSummaryNew(): Promise<AgentCenterResponse> {
    const response = await this.get<AgentCenterResponse, true>(
      "/api/user_invite_new/income_summary_new"
    );
    return response.data.model;
  }

  async agentInvitedInfo(): Promise<AgentInvitedInfoResponse> {
    const response = await this.post<AgentInvitedInfoResponse, true>(
      "/api/user/agent_invited_info"
    );
    return response.data.model;
  }

  /**
   * 获取佣金记录
   * @param params 查询参数
   * @returns Promise<CommissionRecordsResponse>
   */
  async commissionRecordsNew(
    params: CommissionRecordsRequest
  ): Promise<CommissionRecordsResponse> {
    const response = await this.post<CommissionRecordsResponse, true>(
      "/api/user_invite_new/commission_records_new",
      params
    );
    return response.data.model;
  }

  /**
   * 获取收入配置数据
   * @returns Promise<IncomeConfigResponse>
   */
  async incomeConfig(): Promise<IncomeConfigResponse> {
    const response = await this.get<IncomeConfigResponse, true>(
      "/api/user/income_config"
    );
    return response.data.model;
  }

  /**
   * 获取邀请信息数据
   * @returns Promise<InvitedInfoResponse>
   */
  async invitedInfo(): Promise<InvitedInfoResponse> {
    const response = await this.get<InvitedInfoResponse, true>(
      "/api/user/invited_info"
    );
    return response.data.model || response.data.data || response.data;
  }
}
export const agentCenterApi = new AgentCenterApi();
